import { render } from "./chat-image.vue?vue&type=template&id=48273e02"
import script from "./chat-image.vue?vue&type=script&lang=js"
export * from "./chat-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__